import { ToastProgrammatic as Toast } from 'buefy'
import uniq from 'lodash/uniq'
import moment from 'moment'
import { event } from 'vue-analytics'
import firebase from 'firebase/app'

export function trackClick({ label }) {
  event({
    eventCategory: 'Button',
    eventAction: 'click',
    eventLabel: label,
  })
}

export function displayMessage(message) {
  Toast.open({
    duration: 6000,
    message,
    position: 'is-bottom',
  })
}

export function displayError(err) {
  Toast.open({
    message: err.message,
    position: 'is-bottom',
    type: 'is-danger',
    duration: 6000,
  })
}

export const tagRegExp = /#([\w]+)/g
export function getTagsFromLine(line) {
  const matchesArray = line.match(tagRegExp)
  return uniq(matchesArray).map(match => match.replace('#', ''))
}

export function tagToUrl(tag) {
  return `${tag.replace('#', '')}`
}

export const groupByDateFormat = 'MMMM DD'

export function browserHasPush() {
  return firebase.messaging.isSupported()
}

export function getYearForLine(line) {
  const createdAt = line.createdAt.toDate
    ? line.createdAt.toDate() : line.createdAt
  return moment(createdAt).format('YYYY')
}

export function getLineFromStorage() {
  const line = localStorage.getItem('line')
  if (line) {
    localStorage.removeItem('line')
    return JSON.parse(line)
  }

  return null
}

export const POSITIVE_MOOD = 'positive-mood'
export const NEGATIVE_MOOD = 'negative-mood'
export const POSITIVE_THRESHOLD = 1
export const NEGATIVE_THRESHOLD = -1

export function getMoodText(sentimentScore) {
  if (sentimentScore < NEGATIVE_THRESHOLD) {
    return NEGATIVE_MOOD
  }

  if (sentimentScore > POSITIVE_THRESHOLD) {
    return POSITIVE_MOOD
  }

  return null
}
